module.exports = __webpack_public_path__ + "templates/free.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/free/templates/free.html
// module id = GhFr
// module chunks = 1